/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Meta_DescriptionInputs */

const ja_calendar_meta_description = /** @type {(inputs: Calendar_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイブレーン(PLAYBRAIN)が主催または運営しているeスポーツ・ゲーム関連イベントを紹介します。`)
};

const en_calendar_meta_description = /** @type {(inputs: Calendar_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here is an introduction to the esports and game-related events organized or managed by PLAYBRAIN.`)
};

/**
* | output |
* | --- |
* | "Here is an introduction to the esports and game-related events organized or managed by PLAYBRAIN." |
*
* @param {Calendar_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_meta_description = /** @type {((inputs?: Calendar_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_meta_description(inputs)
	return en_calendar_meta_description(inputs)
});